import React from 'react';
import clsx from 'clsx';
import { buildRowActionsRendererDefinition, getColumnsToRender } from 'hooks/datatable';
import { rowClickBuilder } from 'hooks/profileActions';
import DataTable from 'UI/components/organisms/DataTable';
import { useDataTableStyles } from 'UI/globalStyles/DataTableStyles';

import { DUPLICATES_TABLE_COLUMNS } from './DuplicatesTable.constants';

export const DuplicatesTable = ({ data }) => {
  const dataTableClasses = useDataTableStyles();

  const handleViewClick = itemId => {
    if (!itemId) return;
    // TODO: implement logic to see sendout details.
    console.log({ itemId });
  };

  const actionButton = buildRowActionsRendererDefinition({
    actions: [
      {
        name: 'view',
        onClick: rowClickBuilder({
          columns: DUPLICATES_TABLE_COLUMNS,
          data,
          pickId: true,
          callback: handleViewClick
        })
      }
    ]
  });

  const finalColumns = getColumnsToRender([...DUPLICATES_TABLE_COLUMNS, actionButton]);
  return (
    <DataTable
      columns={finalColumns}
      data={data}
      sort
      isServerSide={false}
      filter={false}
      search={false}
      elevation={0}
      pagination={false}
      selectableRowsHeader={false}
      selectableRows="none"
      CustomToolbar={<></>}
      className={clsx(dataTableClasses.withoutToolbar)}
    />
  );
};
